import { render, staticRenderFns } from "./MangeSidebar.vue?vue&type=template&id=741bad20&scoped=true&"
import script from "./MangeSidebar.vue?vue&type=script&lang=js&"
export * from "./MangeSidebar.vue?vue&type=script&lang=js&"
import style0 from "./MangeSidebar.vue?vue&type=style&index=0&id=741bad20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741bad20",
  null
  
)

export default component.exports